<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Main App component for public status pages
</script>

<style>
#app {
  min-height: 100vh;
}
</style>